export const SHOW_TOP_ERROR_NOTIFICATION = 'SHOW_TOP_ERROR_NOTIFICATION';
export const SHOW_TOP_SUCCESS_NOTIFICATION = 'SHOW_TOP_SUCCESS_NOTIFICATION';
export const SHOW_TOP_INFO_NOTIFICATION = 'SHOW_TOP_INFO_NOTIFICAION';
export const SHOW_TOP_WARNING_NOTIFICATION = 'SHOW_TOP_WARNING_NOTIFICATION';

export const CLEAR_ALL_MESSAGES = 'CLEAR_ALL_MESSAGES';